module.exports = __webpack_public_path__ + "img/reserve.42ea9fff.png";